module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAaCAMAAABrajdMAAAAUVBMVEUAAAD/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th6L2N2zAAAAGnRSTlMA7h0O+PTGsqedjFA+OTAkBRPb1r+PgnZzaqU6avsAAAB4SURBVCjPhZJHDsAgEANDeiGF9Pj/D40SgZaqneMcMNhkcWTUjvUVsXMDUQS26Evg9O1yCwCV8vSw4uPw4/BT5rbNW2g6J66CYaa4RwCGluI2WEzaTjtsGh3XwUUmfeocJje8J/OusAemt7BnbhdC0Y6J3fl/QsgXH50Uxbqspu4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/otherLeft.png
// module id = t8wk
// module chunks = 1